const styles = {
  LoginWindow: {
    width: '100%',
    maxWidth: '400px',
    margin: 'auto',
    padding: '2rem'
  }
}

export default styles